import React, { useState } from "react";
import { ProgressTabs } from "ui/tabs";
import { ProductShowcase, ProductShowcaseImage } from "ui/product-showcase";
import firstMobileImage from "../../../../public/assets/platform-overview-content/mobile-product-screen-1.png";
import secondMobileImage from "../../../../public/assets/platform-overview-content/mobile-product-screen-2.png";
import thirdMobileImage from "../../../../public/assets/platform-overview-content/mobile-product-screen-3.png";
import { AudiencesScreen } from "./audiences";
import { JourneysScreen } from "./journeys";
import { CampaignIntelligenceScreen } from "./campaign-intelligence";

export function ProductScreensSlideshow() {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const tabs = [
    {
      title: "Build any audience",
      description: "Explore, build, and test any audience with a no-code suite of tools",
      media: (
        <ProductShowcase
          variant="sunset"
          productScreen={<AudiencesScreen isActive={activeTabIndex === 0} />}
          mobileProductScreen={
            <ProductShowcaseImage
              isMobile
              src={firstMobileImage}
              alt="Hightouch Audience builder named 'USA Active Customers' with filters selecting users with their country equal to 'USA' and had viewed a product greater than $50 within 7 days."
            />
          }
        />
      ),
    },
    {
      title: "Orchestrate customer journeys",
      description: "Easily manage and  prioritize campaigns across your audiences",
      media: (
        <ProductShowcase
          variant="gold"
          productScreen={<JourneysScreen isActive={activeTabIndex === 1} />}
          mobileProductScreen={
            <ProductShowcaseImage
              isMobile
              src={secondMobileImage}
              alt="Hightouch Journey named 'Revival campaign', running a live campaign that sends an email notification to audiences with churn risk."
            />
          }
        />
      ),
    },
    {
      title: "Uncover insights",
      description: "Self-serve answers to all your marketing questions, using AI",
      media: (
        <ProductShowcase
          variant="coastal"
          productScreen={<CampaignIntelligenceScreen isActive={activeTabIndex === 2} />}
          mobileProductScreen={
            <ProductShowcaseImage
              isMobile
              src={thirdMobileImage}
              alt="Hightouch Campaign Intelligence displaying a graph regarding how much revenue a user earned from campaigns within the last year."
            />
          }
        />
      ),
    },
  ];

  return (
    <ProgressTabs
      mt={{ base: "biggest", md: "bigger" }}
      mb={{ base: "huge", md: "biggest" }}
      theme="dark"
      tabs={tabs}
      onChangeTab={(index) => {
        setActiveTabIndex(index);
      }}
    />
  );
}
